module.exports = __webpack_public_path__ + "img/course1.07a90825.png";